export default "__VITE_ASSET__CSqHFVi$__";